import { APP_MAIN } from '../../environments/environment';
import { menuPath } from '../constants/menu';
import jwt_decode from 'jwt-decode';
import { RequestActionType } from '../constants/enum';

export const formatNumber = (num: number) => {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const convertStringNumberToNumber = (numStr: string) => {
    return parseInt(numStr.replace(/,/g, ''));
};

export const getShortName = (fullname: string) => {
    const splitList = fullname.split(' ');
    const filterSplitList = splitList.filter((data) => data !== '' && data);
    const firstChar = filterSplitList.length > 0 ? filterSplitList[0] : '';
    const secondChar =
        filterSplitList.length > 0 && filterSplitList.length > 1
            ? filterSplitList[filterSplitList.length - 1]
            : '';
    const result = `${firstChar.charAt(0)}${secondChar.charAt(
        0
    )}`?.toUpperCase?.();
    return result;
};

export const getUrlWithoutHttp = (url: string) => {
    let result = url
        .replace(APP_MAIN, '')
        .replace('https://', '')
        .replace('http://', '');

    return result;
};

export const getSubUrl = (url: string) => {
    let result = url
        .replace(APP_MAIN, '')
        .replace('https://', '')
        .replace('http://', '');
    if (result.slice(-1) === '/') {
        result = result.substring(0, result.length - 1);
    }

    return result;
};

export const menuSidebarFormatter = (menu: MenuResponseType) => {
    const menuUser: MenuSidebarItemType[] = menu?.user?.map(
        (item: MenuItemResponseType) => ({
            id: item.id,
            title: item.nameTh,
            path:
                menuPath.find((item2: MenuPathType) => item.id === item2.id)
                    .path || '',
            functionId: item.functionId,
        })
    );
    const menuAdmin: MenuSidebarItemType[] = menu?.admin?.map(
        (item: MenuItemResponseType) => ({
            id: item.id,
            title: item.nameTh,
            path:
                menuPath.find((item2: MenuPathType) => item.id === item2.id)
                    .path || '',
            functionId: item.functionId,
        })
    );
    let addManualOther = menu?.other?.map((data) => ({ ...data })) ?? [];
    addManualOther = [
        ...addManualOther,
        {
            id: 'custom_id_manual',
            nameTh: 'คู่มือการใช้งานระบบ',
            nameEn: 'User Manual',
            functionId: '',
        },
        {
            id: 'custom_id_download_mobile',
            nameTh: 'ดาวน์โหลด Mobile',
            nameEn: 'Download Mobile',
            functionId: '',
        },
    ];
    const menuOther: MenuSidebarItemType[] = addManualOther.map(
        (item: MenuItemResponseType) => ({
            id: item.id,
            title: item.nameTh,
            path:
                menuPath.find((item2: MenuPathType) => item.id === item2.id)
                    .path || '',
            functionId: item.functionId,
        })
    );

    let result: MenuSidebarType = {
        user: menuUser,
        admin: menuAdmin,
        other: menuOther,
    };

    return result;
};

export const menuShortcutFormatter = (
    menu: MenuShortcutResponseType[] = []
) => {
    const result: MenuShortcutType[] = menu?.map(
        (item: MenuShortcutResponseType) => ({
            id: item.id,
            title: item.nameTh,
            description: item.descriptionTh,
            path:
                menuPath.find((item2: MenuPathType) => item.id === item2.id)
                    .path || '',
            icon:
                menuPath.find((item2: MenuPathType) => item.id === item2.id)
                    .icon || '',
        })
    );

    return result;
};

export const canAccessMenu = (keyMenuList: string[], url: string) => {
    const currentUrl = url.substring(1);

    const menuPermission = menuPath.filter((item) =>
        keyMenuList.includes(item.id)
    );
    /**
     * const menu = menuPermission.find((item) => {
            console.log('item', item)
            let isPermit = false;
            if (item.subPath.length > 0) {
                const filterMenu = (
                    item.subPath.filter((subPath) => {
                        const concatURL = `${item.path}${subPath}`;
                        const equalLengthURL = url.substring(concatURL.length - 1).substring(1);
                        console.log('equalLengthURL', equalLengthURL, concatURL);
                        return (item.path + subPath).includes(currentUrl);
                    })
                )
                console.log('filterMenu', filterMenu);
                isPermit = filterMenu.length > 0;
            } else {
                const firstCondition = item.path.includes(currentUrl);
                const secondCondition = currentUrl.length >= (item.path.length - 1);
                if (firstCondition && secondCondition) {
                    isPermit = true;
                }
            }
            return isPermit;
        });
     */
    let isPermit = false;
    menuPermission.forEach((menuItem) => {
        if (!isPermit) {
            if (menuItem.subPath.length > 0) {
                isPermit = menuItem.subPath.find((subPath) => {
                    const concatURL = `${menuItem.path}${subPath}`;
                    const condition = concatURL.length < url.length;
                    return condition
                        ? url.includes(concatURL)
                        : concatURL.includes(currentUrl);
                })
                    ? true
                    : false;
            } else {
                const firstCondition = menuItem.path.includes(currentUrl);
                const secondCondition =
                    currentUrl.length >= menuItem.path.length - 1;
                if (firstCondition && secondCondition) {
                    isPermit = true;
                }
            }
        }
    });
    return isPermit || currentUrl.includes('message') ? true : false;
};

export const addCommas = (num: number) => {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const generateGoogleMapUrl = (
    latitude: number,
    longitude: number,
    type: 'Normal' | 'StreetView' = 'StreetView'
) => {
    if (type === 'Normal') {
        return `http://maps.google.com/maps?q=&layer=t&cbll=${latitude},${longitude}&mapmode=streetview`;
    } else {
        return `http://maps.google.com/?cbll=${latitude},${longitude}&cbp=12,20.09,,0,5&layer=c`;
    }
};

export const checkExpiredToken = (token: string) => {
    let decoded = jwt_decode(token) as any;
    const fixExp = Number(`${decoded.exp}000`);
    return Date.now() > fixExp;
};

export const getUserActions = (statusId: string) => {
    let initAction = [RequestActionType.CAN_VIEW];
    if (statusId === '-1' || statusId === '0') {
        initAction = [RequestActionType.CAN_DELETE, RequestActionType.CAN_EDIT];
    } else if (statusId === '1') {
        initAction = [RequestActionType.CAN_VIEW, RequestActionType.CAN_CANCEL];
    }

    return initAction;
};

export const numberWithCommas = (_number: Number) => {
    return _number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const getCurrentTaxYear = () => {
    let buddhistYear = new Date().getFullYear() + 543;
    const currentMonth = new Date().getMonth() + 1;
    if (currentMonth >= 10) {
        buddhistYear += 1;
    }
    return buddhistYear;
};
